import React from 'react';
import ProductsTable from '../../components/Products/ProductsTable';

export default function ProductsPage() {
  return (
    <div>
      <ProductsTable />
    </div>
  );
}
